module.exports = __webpack_public_path__ + "img/logo-um-pf.f50e210a.png";